import React from 'react';
import { Flex, Chip, ChipGroup } from '@applyboard/crystal-ui';

import { QueryParameters } from './types';
import { QueryParameterContextState } from './context';

export function FilterSummary<Parameters extends QueryParameters>(state: QueryParameterContextState<Parameters>) {
  const { filterSummaries, removeQueryParameterValue, resetQueryParameters } = state;

  const chips = React.useMemo(() => {
    const result = filterSummaries.map((summaryItem) => (
      <Chip
        key={summaryItem.key}
        onDelete={() => {
          removeQueryParameterValue(summaryItem.filterKey, summaryItem.value);
        }}
      >
        {summaryItem.label}
      </Chip>
    ));
    result.push(
      <ChipGroup.ClearAllButton
        key="clear-all"
        onClick={() => {
          resetQueryParameters();
        }}
      >
        Clear all filters
      </ChipGroup.ClearAllButton>
    );
    return result;
  }, [filterSummaries, resetQueryParameters, removeQueryParameterValue]);

  if (filterSummaries.length === 0) return null;
  return (
    <Flex justify="between" gap={1} align="center">
      <ChipGroup size="sm" lines={1} variant="outlined">
        {chips}
      </ChipGroup>
    </Flex>
  );
}
